import { I18n } from "./i18n";

export const i18nPl: I18n = {
  unsupportedBrowser: "Twoja przeglądarka nie jest obsługiwana. Uaktualnij do nowszej wersji lub spróbuj na innej",
  videoDeleted: "Przepraszamy, ten film nie jest już dostępny.",
  videoInPreparation: "Film już za chwilę będzie dostępny<br/>Przeładuj stronę za jakiś czas!",

  sendReport: "Wyślij raport",
  thankYouForSendingReport: "Dziękujemy za wysłanie zgłoszenia",
  configurationParsingFailure: "Konfiguracja odtwarzacza jest nieprawidłowa",
  resourceLoadingFailure: "Wystąpił błąd w czasie ładowania elementów scenariusza",
  playbackFailure: "Wystąpił błąd",
  runtimeError: "Wystąpił błąd",

  subtitles: "Napisy",
  part: "Część",
  play: "Włącz",
  pause: "Zatrzymaj",
  replay: "Odtwórz ponownie",
  mute: "Wycisz",
  unmute: "Włącz głos",
  share: "Udostępnij",
  fullscreen: "Pełny ekran",
  exitFullscreen: "Wróć do małego ekranu",
  poweredByVintom: "Powered by Vintom",
  licenceAdditionalText: "Read",
  licenceLabel: "player licence",
  linkLicence: "https://player2.vintom.com/player/Vintom_player_terms_of_use.pdf",

  bandwidth: "Pasmo",
  mbps: "Mbps",

  facebook: "Facebook",
  twitter: "Twitter",

  videoInPreparationLoadingPage: "Film nie jest jeszcze gotowy. Spróbuj przeładować stronę za jakiś czas",
};
